import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function GovbrCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasRunOnce = useRef(false);

  useEffect(() => {
    if (hasRunOnce.current) {
      //console.log('⛔ [GovbrCallback] Fluxo já executado, evitando chamada duplicada.');
      return;
    }
    hasRunOnce.current = true;
    //console.log('🔄 [GovbrCallback] Iniciando processamento do callback...');
    
    const params = new URLSearchParams(location.search);
    const msg = params.get('msg');
    const guid = params.get('GUID');
    const authenticated = msg === 'Authenticated';

    //console.log('📋 [GovbrCallback] Parâmetros da URL:');
    //console.log('   - msg:', msg);
    //console.log('   - GUID:', guid);
    //console.log('   - authenticated:', authenticated);

    if (guid) {
      //console.log('✅ [GovbrCallback] GUID encontrado, iniciando fluxo de autenticação...');
      
      // Pegar dados do localStorage
      //console.log('💾 [GovbrCallback] Recuperando dados do localStorage...');
      const urlbase = localStorage.getItem('storageLink') || localStorage.getItem('link') || localStorage.getItem('urlbase');
      const storedChave = localStorage.getItem('chave') || '066979d925a762cff76230f51fb829fb';
      
      //console.log('   - urlbase:', urlbase ? urlbase : 'ausente');
      //console.log('   - chave:', storedChave ? storedChave : 'ausente');

      if (!urlbase) {
        //console.error('❌ [GovbrCallback] URL base não encontrada no localStorage');
        //console.error('   - URL Base:', urlbase);
        return;
      }

      // Primeiro: Chamar apiloginmobile para obter o token
      const loginUrl = `${urlbase}/apiloginmobile.rule?sys=SAU&chave=${storedChave}&GUID=${guid}`;
      //console.log('🔗 [GovbrCallback] URL de login móvel construída:');
      //console.log('   - URL:', loginUrl);
      //console.log('   - Parâmetros:');
      //console.log('     * sys: SAU');
      //console.log('     * chave:', storedChave);
      //console.log('     * GUID:', guid);

      //console.log('🌐 [GovbrCallback] Fazendo requisição para API de login móvel...');
      axios.get(loginUrl)
        .then(response => {
          //console.log('📥 [GovbrCallback] Resposta da API de login móvel (apiloginmobile) recebida:');
          //console.log('   - Status:', response.status);
          //console.log('   - Headers:', response.headers);
          //console.log('   - Dados completos:', response.data);
          //console.log('   - Tipo de dados:', typeof response.data);
          
          if (response.data?.token) {
            const tokenRecebido = response.data.token.toString();
            //console.log('✅ [GovbrCallback] Token obtido da apiloginmobile:', tokenRecebido);
            
            // Segundo: Chamar wsVerificar com o token para obter o CPF
            const wsVerificar = "https://loginunico.portoreal.rj.gov.br/loginunico/WSAuthVerify.rule?sys=SLU&token=" + tokenRecebido;
            //console.log('🔗 [GovbrCallback] URL do wsVerificar:');
            //console.log('   - URL:', wsVerificar);
            //console.log('   - token:', tokenRecebido);

            //console.log('🌐 [GovbrCallback] Fazendo requisição para wsVerificar...');
            return axios.get(wsVerificar).then(wsResponse => {
              //console.log('📥 [GovbrCallback] Resposta do wsVerificar recebida:');
              //console.log('   - Status:', wsResponse.status);
              //console.log('   - Headers:', wsResponse.headers);
              //console.log('   - Dados completos:', wsResponse.data);
              //console.log('   - Tipo de dados:', typeof wsResponse.data);
              
              return { token: tokenRecebido, wsData: wsResponse.data };
            });
          } else {
            //console.error('❌ [GovbrCallback] Token não encontrado na resposta da apiloginmobile');
            //console.error('   - Resposta completa:', response.data);
            throw new Error('Token não encontrado');
          }
        })
        .then(result => {
          const { token, wsData } = result;
          
          if (wsData?.cpf) {
            const cpf = wsData.cpf.toString();
            //console.log('✅ [GovbrCallback] CPF obtido do wsVerificar:', cpf);
            
            // Terceiro: Chamar apiloginmobile com cpf e CPF
            const loginUrlFinal = `${urlbase}/apiloginmobile.rule?sys=SAU&chave=${storedChave}&cpf=${cpf}&GUID=${guid}`;
            //console.log('🔗 [GovbrCallback] URL de login móvel final construída:');
            //console.log('   - URL:', loginUrlFinal);
            //console.log('   - Parâmetros:');
            //console.log('     * sys: SAU');
            //console.log('     * chave:', storedChave);
            //console.log('     * cpf:', cpf);

            //console.log('🌐 [GovbrCallback] Fazendo requisição final para API de login móvel...');
            return axios.get(loginUrlFinal).then(finalResponse => {
              //console.log('📥 [GovbrCallback] Resposta final da API de login móvel recebida:');
              //console.log('   - Status:', finalResponse.status);
              //console.log('   - Headers:', finalResponse.headers);
              //console.log('   - Dados completos:', finalResponse.data);
              //console.log('   - Tipo de dados:', typeof finalResponse.data);
              
              return finalResponse.data;
            });
          } else {
            //console.error('❌ [GovbrCallback] CPF não encontrado na resposta do wsVerificar');
            //console.error('   - Resposta completa:', wsData);
            throw new Error('CPF não encontrado');
          }
        })
        .then(finalData => {
          //console.log('✅ [GovbrCallback] Autenticação GOV.BR concluída com sucesso');
          //console.log('   - Dados finais:', finalData);
          
          // Definir autenticação sem armazenar dados sensíveis
          localStorage.setItem('autenticado', 'true');
          
          //console.log('🚀 [GovbrCallback] Navegando para /Menu...');
          navigate('/Menu');
        })
        .catch(error => {
          //console.error('❌ [GovbrCallback] Erro nas requisições:');
          if (error.response) {
            //console.error('   - Status:', error.response.status);
            //console.error('   - Status Text:', error.response.statusText);
            //console.error('   - Headers:', error.response.headers);
            //console.error('   - Dados do erro:', error.response.data);
            //console.error('   - Config:', error.config);
          } else if (error.request) {
            //console.error('   - Nenhuma resposta recebida');
            //console.error('   - Request:', error.request);
          } else {
            //console.error('   - Mensagem:', error.message);
            //console.error('   - Stack:', error.stack);
          }
        });
    } else {
      //console.log('⚠️ [GovbrCallback] GUID não encontrado nos parâmetros');
    }
  }, [location, navigate]);

  return (
    <div style={{ padding: '24px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Autenticação GOV.BR</h1>
      <p>Finalizando o login...</p>
      <p>Se esta página não redirecionar automaticamente, você pode fechar a aba.</p>
    </div>
  );
}
